const link = {
  defaultProps: {
    color: "inherit",
  },
};

export default link;
